import React from 'react';
import { TextFieldProps } from '@mui/material/TextField';
import { TextFieldStyled } from './j-text-field-base.styled';

export interface JTextFieldBaseProps extends Omit<TextFieldProps, ''> {
  noBorder?: boolean;
  attr?: { whiteBg?: boolean };
  helpertextinside?: string;
}
const JTextFieldBase: React.FC<JTextFieldBaseProps> = ({
  noBorder = false,
  attr: { whiteBg = false } = {},
  helpertextinside: helperTextInside,
  name,
  label,
  ...props
}) => {
  return (
    <TextFieldStyled
      attr={{ whiteBg }}
      label={label}
      name={name}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      }}
      helpertextinside={helperTextInside}
      autoComplete="off"
      variant="filled"
      inputProps={{ 'data-qa': `input-${name ?? label}` }}
      {...props}
    />
  );
};

export default JTextFieldBase;
